import { GraphQLResponse } from "./models";

export function getFrontMatter<T>(props: GraphQLResponse<T>) {
  return props.data.allFile.edges[0].node.childMarkdownRemark.frontmatter;
}
